import { AxiosRequestTransformer } from "axios"
import { format } from "date-fns";

export const adjustForUTCOffset = date => {
    return new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
    );
  };

// translate dates for DB
export const requestTransformer: AxiosRequestTransformer = (data, headers) => {
    if (data instanceof Date) {
      // do your specific formatting here
    //   const adjusted = adjustForUTCOffset(data);
      return format(data, 'yyyy-MM-dd HH:mm:ss')
    //   console.log(data, adjustForUTCOffset(data));
    //   return data.toISOString();
    }
    if (Array.isArray(data)) {
      return data.map(val => requestTransformer(val, headers))
    }
    if (typeof data === "object" && data !== null) {
      return Object.fromEntries(Object.entries(data).map(([ key, val ]) =>
        [ key, requestTransformer(val, headers) ]))
    }
    return data
}
